import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import FirstPlaceIcon from '../assets/first-pl.svg'; // Путь к иконке
import SecondPlaceIcon from '../assets/sec-pl.svg';
import ThirdPlaceIcon from '../assets/thr-pl.svg';
import config from "../config";
import { useSelector } from 'react-redux'; // Подключаем useSelector для Redux
import Header from './Header'; // Добавляем импорт Header
import TeamIcon from '../assets/team-icon.svg'; // Используем иконку команды

const RatingTable = () => {
    const [ratingData, setRatingData] = useState([]);
    const [, setError] = useState(null);
    const [editedData, setEditedData] = useState([]); // Для хранения редактируемых данных
    const adminMode = useSelector((state) => state.adminMode.adminMode);
    const userGender = useSelector((state) => state.user.gender);
    const initData = window.Telegram.WebApp.initData;
    const [activeTab, setActiveTab] = useState('Мужской');
    const containerRef = useRef(null);

    useEffect(() => {
        const gender = adminMode ? activeTab : userGender;
        const genderParam = gender === 'Женский' ? 'woman' : 'man';

        axios.get(`${config.API_BASE_URL}/rating/get?gen=${genderParam}`)
            .then(response => {
                if (response.data.success) {
                    let data = response.data.data;

                    // Сортировка данных в зависимости от режима
                    if (adminMode) {
                        // В режиме админа сортируем по номеру команды
                        data = [...data].sort((a, b) => parseInt(a.groupNumber) - parseInt(b.groupNumber));
                    }

                    setRatingData(data);
                    setEditedData(data.map(item => ({ ...item }))); // Создаём копию данных для редактирования
                } else {
                    setError('Не удалось загрузить данные рейтинга');
                }
            })
            .catch(err => {
                console.error('Ошибка при запросе рейтинга:', err);
                setError('Ошибка при загрузке данных');
            });
    }, [activeTab, userGender, adminMode]);

    const handleInputChange = (e, index, field) => {
        const value = e.target.value.replace(/[^0-9]/g, ''); // Убираем все нецифровые символы
        const newData = [...editedData];
        newData[index][field] = value; // Обновляем только цифры
        setEditedData(newData);
    };

    // Функция для сохранения изменений
    const handleSave = () => {
        const genderParam = activeTab === 'Женский' ? 'woman' : 'man';

        axios.post(`${config.API_BASE_URL}/rating/save`, {
            editedData,
            initData,
            activeTab: genderParam
        })
            .then(response => {
                if (response.data.success) {
                    setRatingData(editedData); // Обновляем данные, если сохранение прошло успешно
                }
            })
            .catch(err => {
                console.error('Ошибка при сохранении данных:', err);
            });
    };

    return (
        <>
            <Header />
            <div className="rating-page-container" ref={containerRef}>
                <div className="rating-title-wrapper">
                    <h2 className="rating-title-label">ТАБЛИЦА ЛИДЕРОВ</h2>
                </div>

                <div className="rating-content-container">
                    {adminMode && (
                        <div className="admin-controls">
                            <div className="tabs-container">
                                <button
                                    className={`tab-button ${activeTab === 'Мужской' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('Мужской')}
                                >
                                    Мужской рейтинг
                                </button>
                                <button
                                    className={`tab-button ${activeTab === 'Женский' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('Женский')}
                                >
                                    Женский рейтинг
                                </button>
                            </div>
                            <button onClick={handleSave} className="save-button">
                                Сохранить изменения
                            </button>
                        </div>
                    )}

                    <div className="rating-scroll-container">
                        <div className="rating-container">
                            <div className="rating-list">
                                <div className="rating-header">
                                    <div className="rating-column">МЕСТО</div>
                                    <div className="rating-column">НОМЕР КОМАНДЫ</div>
                                    <div className="rating-column">КОЛ-ВО ОТЧЕТОВ</div>
                                </div>

                                {ratingData.map((item, index) => (
                                    <div key={index} className='main-rating'>
                                        <div className={`rating-row`}>
                                            <div className="rating-column place-column">
                                                {adminMode ? (
                                                    <input
                                                        type="string"
                                                        value={editedData[index]?.place}
                                                        onChange={(e) => handleInputChange(e, index, 'place')}
                                                    />
                                                ) : (
                                                    <>
                                                        {index === 0 ? (
                                                            <img src={FirstPlaceIcon} alt="First Place" className="place-icon" />
                                                        ) : index === 1 ? (
                                                            <img src={SecondPlaceIcon} alt="Second Place" className="place-icon" />
                                                        ) : index === 2 ? (
                                                            <img src={ThirdPlaceIcon} alt="Third Place" className="place-icon" />
                                                        ) : (
                                                            <div className="place-num">{item.place}</div>
                                                        )}
                                                        <img src={TeamIcon} alt="Team" className="team-icon" />
                                                    </>
                                                )}
                                            </div>
                                            <div className="rating-column team-column">
                                                {adminMode ? (
                                                    <input
                                                        type="string"
                                                        value={editedData[index]?.groupNumber}
                                                        onChange={(e) => handleInputChange(e, index, 'groupNumber')}
                                                    />
                                                ) : (
                                                    <div className="team-info">
                                                        <span className="team-name">Команда №{item.groupNumber}</span>
                                                    </div>
                                                )}
                                            </div>
                                            <div className="rating-column report-column">
                                                {adminMode ? (
                                                    <input
                                                        type="string"
                                                        value={editedData[index]?.reportCount}
                                                        onChange={(e) => handleInputChange(e, index, 'reportCount')}
                                                    />
                                                ) : (
                                                    <div className="report-count">{item.reportCount}</div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default RatingTable;
